import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import AMPLITUDE_EVENT_VALUES from '../../consts/amplitude/amplitudeEventValues';
import AD_FLOW_NAMES from '../../consts/uam/advanceDiagnosticFlowNames';
import {selectIsHolderConnected} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import log from '../logger/log';
import advanceDiagnosticService from '../yap/advanceDiagnosticService';
import amplitude from './amplitude';

const trackADStarted = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.AD_STARTED);

    log.info(`AD: eventType: ${AMPLITUDE_EVENT_TYPES.AD_STARTED}`);
};

const trackADInitialQuestionnaireViewed = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.AD_INITIAL_QUESTIONNAIRE_VIEWED);

    log.info(`AD: eventType: ${AMPLITUDE_EVENT_TYPES.AD_INITIAL_QUESTIONNAIRE_VIEWED}`);
};

const trackProductADInitialQuestionnaireViewed = (isHolder) => {
    const isHolderConnected = selectIsHolderConnected(getState());
    const eventProps = {
        isHolder: isHolder && isHolderConnected,
        eventType: AMPLITUDE_EVENT_TYPES.AD_INITIAL_QUESTIONNAIRE_VIEWED,
    };

    amplitude.trackProductEvent(eventProps);

    log.info(`AD: eventType: ${eventProps.eventType}, isHolder: ${eventProps.isHolder}`);
};

const trackADAutoDiagnosticStarted = (isHolder) => {
    const eventProps = {
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.AD_AUTO_DIAGNOSTICS_STARTED,
    };

    amplitude.trackProductEvent(eventProps);

    log.info(`AD: eventType: ${eventProps.eventType}, isHolder: ${eventProps.isHolder}`);
};

const trackADCompleted = ({isHolder, inferenceCode}) => {
    const eventProps = {
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.AD_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.DIAGNOSTIC_MESSAGE]: inferenceCode,
        },
    };

    amplitude.trackProductEvent(eventProps);

    log.info(
        `AD: eventType: ${eventProps.eventType}, isHolder: ${eventProps.isHolder}, properties: ${JSON.stringify(
            eventProps.properties
        )}`
    );
};

const trackADCompletedResolutionScreen = ({inferenceCode, isHolder, deviceState}) => {
    if (inferenceCode === undefined || deviceState === undefined) return;

    // if inferenceCode is null and deviceState is null, this is a success flow
    const isSuccessFlow = inferenceCode === null && deviceState === null;
    const flowName = isSuccessFlow
        ? AD_FLOW_NAMES.SUCCESS_FLOW
        : advanceDiagnosticService.getDeviceConfigByInferenceCode(inferenceCode, isHolder, deviceState)?.flow?.name;
    let resolutionMessage;

    switch (flowName) {
        case AD_FLOW_NAMES.MARKET_FLOW:
            resolutionMessage = AMPLITUDE_EVENT_VALUES.AD_SCENARIO_1;
            break;
        case AD_FLOW_NAMES.FWU_CHECK_AND_RESET_FLOW:
            resolutionMessage = AMPLITUDE_EVENT_VALUES.AD_SCENARIO_2;
            break;
        case AD_FLOW_NAMES.FWU_CHECK_AND_ADAPTOR_MSG_FLOW:
            resolutionMessage = AMPLITUDE_EVENT_VALUES.AD_SCENARIO_3;
            break;
        case AD_FLOW_NAMES.FWU_CHECK_AND_MARKET_FLOW:
            resolutionMessage = AMPLITUDE_EVENT_VALUES.AD_SCENARIO_FW;
            break;
        case AD_FLOW_NAMES.SUCCESS_FLOW:
            resolutionMessage = AMPLITUDE_EVENT_VALUES.AD_SCENARIO_NO_ERRORS;
            break;
        default:
            break;
    }

    const eventProps = {
        flowName,
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.AD_COMPLETED_RESOLUTION_SCREEN,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.RESOLUTION_MESSAGE]: resolutionMessage,
        },
    };

    amplitude.trackProductEvent(eventProps);

    log.info(
        `AD: ${!!flowName && 'flowName: ' + flowName}, eventType: ${eventProps.eventType}, isHolder: ${
            eventProps.isHolder
        }, properties: ${JSON.stringify(eventProps.properties)}`
    );
};

export default {
    trackADStarted,
    trackADInitialQuestionnaireViewed,
    trackProductADInitialQuestionnaireViewed,
    trackADAutoDiagnosticStarted,
    trackADCompleted,
    trackADCompletedResolutionScreen,
};
